module.exports = __webpack_public_path__ + "static/media/top_shape_5.04fdade5.svg";